import styled from 'styled-components';
import { Typography, Radio } from 'antd';
import colors from '../../../styles/colors';

const { Text } = Typography;

export const ContentHistory = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  margin-top: 18px;

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #f4f4f4;
    margin: 2px 0;
    border-radius: 20px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 20px;
  }
`;

export const OptionRadio = styled(Radio)`
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: #707070;

  .ant-radio-inner {
    border-color: #bdbdbd;
    box-sizing: border-box;
  }
  .ant-radio-inner::after {
    background-color: #24A95D;
    border-color:#24A95D;
  }
`;

export const CardDivergent = styled.div`
  background: #f2f2f2;
  border-radius: 2px;
  padding: 8px 0;
  margin: 7px 0;
`;

export const TextDivergent = styled(Text)`
  color: ${colors.greyText};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
`;

export const ContainerHistory = styled.div`
  margin-top: 8px;
`;

export const CardHistory = styled.div`
  background: ${colors.gbGrey};
  border-radius: 2px;
  padding: 12px;
  width: 100%;
`;

export const TextHistory = styled(Text)`
  color: ${colors.greyText};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
`;

export const BoxTextTime = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TextTime = styled(Text)`
  font-size: 11px;
  line-height: 22px;
  font-style: normal;
  font-weight: normal;
  color: #bdbdbd;
  align-items: flex-end;
`;

export const ContainerArticles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 13px 28px 0 0;
`;

export const TextArticles = styled(Text)`
  font-size: 14px;
  line-height: 16px;
  margin-top: 3px;
  color: ${colors.greyText};
`;
